import { defineMessages } from 'react-intl';

const _default_1: {
	showMoreButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	showMoreButtonText: {
		id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
		defaultMessage: 'Show more',
		description: 'Clicking this button will load more items into the dropdown',
	},
});
export default _default_1;
